export default "__VITE_ASSET__BGq5jGau__"